<template>
    <Popup :showPopup="showProfile" :wide="true" header="Profile" @close-popup="$emit('close-profile-pop')">
        <template v-slot:content>
            <div class="slider statusSlider" v-if="user.Phonecode && !mobileView">
                <button :class="{active: classStatus.available}" @click="$emit('status-available')"> 
                    <div class="statusIndicator"></div>
                    Available 
                </button>
                <button :class="{active: classStatus.notavailable}" @click="$emit('status-unavailable')"> 
                    <div class="statusIndicator unavailable"></div>
                    Unavailable 
                </button>
            </div>

            <div class="userDetails">
                <UserAvatar :mobileView="mobileView" :user="user" :classStatus="classStatus"></UserAvatar>
                <div class="userInfo" :class="{fullwidth: user.Phonecode}">
                    <div class='userInfoTop'>
                        <label v-if='user.Phonecode'>Name</label>
                        <label class='logout' @click="$emit('logout')">Logout</label>
                    </div>
                    <slot name="userNameInput"></slot>
                </div>
            </div>

            <div class='phoneWrap'>
                <div class="directPhone">
                    <label>Direct Phone</label>
                    <slot name="userPhoneInput"></slot>
                </div>
                <div class='mobilePhone'>
                    <label>Mobile Phone</label>
                    <slot name="userMobilePhoneInput"></slot>
                </div>
            </div>

            <p v-if='!user.Phonecode'>Please set up a phone code in your <a :href='mxYouLink' target="_blank">Staff Profile.</a></p>

            <div class='textNotifications'>
                <div class='sliderSet'>
                    <label>Text Notifications</label>
                    <div class='slider' :class="{disabled: !profile.userMobilePhone }">
                        <button :disabled="!profile.userMobilePhone" :class="{ active: textNotificationsOn }" @click="$emit('toggle-text-notes')">ON</button>
                        <button :disabled="!profile.userMobilePhone" :class="{ active: !textNotificationsOn }" @click="$emit('toggle-text-notes')">OFF</button>
                    </div>
                </div>
                <div class="disclaimer" v-if='profile.userMobilePhone'>
                    Message and data rates may apply. By turning this setting ON, you agree to receieve noitfications via text pertaining to the Call Box App. Reply STOP to opt-out of Call Box App text alerts at any time. 
                </div>
            </div>

            <div class='sliderSet' v-if="serviceWorkerExists && !mobileView">
                <label>Desktop Notifications</label>
                <div class='slider'>
                    <button :class="{ active: NotificationsOn }" @click="$emit('toggle-notes')">ON</button>
                    <button :class="{ active: !NotificationsOn }" @click="$emit('toggle-notes')">OFF</button>
                </div>
            </div>
        </template>
        
        <template v-slot:buttons>
            <slot name="button"></slot>
        </template>
    </Popup>
</template>

<script>
import Popup from '@/components/Popup';
import UserAvatar from '@/components/UserAvatar';

export default {
    name: 'ProfileEditPopup',
    props: ['showProfile', 'mobileView', 'user', 'profile', 'classStatus', 'mxYouLink', 'textNotificationsOn', 'serviceWorkerExists', 'NotificationsOn'],
    components: { Popup, UserAvatar }
}
</script>